<template>
  <div class="Scene">
    <canvas ref="canvas" />
  </div>
</template>

<script>
import * as BABYLON from 'babylonjs'
import 'babylonjs-loaders'

BABYLON.SceneLoader.OnPluginActivatedObservable.add(plugin => {
  if(plugin.name === "gltf" && plugin instanceof BABYLON.GLTFFileLoader) {
    plugin.animationStartMode = BABYLON.GLTFLoaderAnimationStartMode.NONE
		plugin.compileMaterials = true
  }
})

export default {
  name: 'Scene',
  beforeDestroy() {
    this.$scene.dispose()
    window.removeEventListener('resize', this.onResize)
  },
  created() {
		this.$store.commit('loader/PROMISE_PUSH', new Promise((resolve, reject) => this.resolveGLTF = resolve))
  },
  computed: {
    render() { return this.$store.getters['app/render'] },
  },
  mounted() {
    
    window.addEventListener('resize', this.onResize)
    const canvas = document.getElementsByTagName('canvas')[0]
    const engine = new BABYLON.Engine(this.$refs.canvas, true, {
      preserveDrawingBuffer: true,
      stencil: true,
      limitDeviceRatio: 1
    })
  
    engine.getInputElement = () => canvas

    const scene = new BABYLON.Scene(engine)
    const camera = new BABYLON[navigator.maxTouchPoints == 5 || this.$root.$agent.tablet ? 'DeviceOrientationCamera' : 'FreeCamera']("Camera", new BABYLON.Vector3(0, 0, -20), scene)

    this.$engine = engine
    this.$scene = scene
    this.$parent.$engine = engine
    this.$parent.$scene = scene
    this.$parent.$camera = camera
    this.$parent.$canvas = this.$refs.canvas

    engine.runRenderLoop(() => {
      if(!this.render) return
      scene.render()
    })

    // this.$root.galaxyTexture = new BABYLON.CubeTexture(`/static/${this.$root.quality}/galaxy/galaxy`, scene) 
    this.$root.galaxyTexture = new BABYLON.CubeTexture(`/static/high/galaxy/galaxy`, scene)   

    const folder = (this.$root.$theme == 'original') ? 'scene' : 'momenta_07'
    const model = (this.$root.$theme == 'original') ? 'scene.gltf' : 'scene_07.gltf'

    BABYLON.SceneLoader.ImportMesh('', `/static/${this.$root.quality}/${folder}/`, model, scene, meshs => {
      this.$parent.$meshs = meshs

      // _.each(meshs, (mesh, i)=>{
      //   // if(mesh.name.split('o_').length == 2){
      //     console.log(i, mesh.name);
      //     // if(mesh.material) {
      //     //   // console.log(mesh.material.albedoTexture.url);
      //     //   const textureOriginal = new BABYLON.Texture(mesh.material.albedoTexture.url, scene)
      //     //   console.log(' .. '+ textureOriginal);
      //     // }
      //     // console.log(mesh);
      //   // }
      //   // if(mesh.name == 'o_KIM_MAT_MR_oKIM_0')
      //   // // if(mesh.name == 'o_JJ LEVINE')
      //   //   console.log(mesh);
      // })
      // // console.log(meshs.length);
      // console.log('xxxxxxxxxxxxxx ------ xxxxxx');

      this.resolveGLTF()
    }, e => {
      this.$store.commit('loader/SET_PROGRESS', { type: 'scene', value: e.loaded / 41273684 })
    })
  },
  methods: {
    onResize() { this.$engine.resize() },
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'

.Scene
  height 100vh
  width 100vw
  overflow hidden
  position absolute
  top 0px
  left 0px

  canvas
    position absolute
    top 0px
    left 0px
    width 100%
    height 100%
</style>



// WEBPACK FOOTER //
// src/components/world/elements/Scene.vue